import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76f3334a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hero column is-narrow pb-0" }
const _hoisted_2 = {
  class: "navbar",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_3 = { class: "navbar-brand" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "navbar-start" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Products")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Services")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Team")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Contact")
const _hoisted_14 = { class: "navbar-end" }
const _hoisted_15 = {
  key: 0,
  class: "buttons"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Profile")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Reports")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Logout")
const _hoisted_19 = {
  key: 0,
  class: "hero-body has-text-centered"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("h1", {
    class: "title",
    style: {"margin":"8rem 0"}
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/aureis-logo.png",
      alt: "Aureis"
    }),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1))
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          role: "button",
          class: _normalizeClass(["navbar-burger", { 'is-active': _ctx.navbarMenu }]),
          "aria-label": "menu",
          "aria-expanded": "false",
          "data-target": "navbarBasic",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showMenu && _ctx.showMenu(...args)))
        }, _hoisted_7, 2)
      ]),
      _createElementVNode("div", {
        id: "navbarBasic",
        class: _normalizeClass(["navbar-menu", { 'is-active': _ctx.navbarMenu }])
      }, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: "/#about",
            class: "navbar-item"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/#products",
            class: "navbar-item"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/#services",
            class: "navbar-item"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/#team",
            class: "navbar-item"
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/#contact",
            class: "navbar-item"
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          (!_ctx.logged)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("button", {
                  class: "navbar-item button is-info",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.push('/register.html')), ["prevent"]))
                }, "Register"),
                _createElementVNode("button", {
                  class: "navbar-item button is-info",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$router.push('/login.html')), ["prevent"]))
                }, "Login")
              ]))
            : _createCommentVNode("", true),
          (_ctx.logged)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "/profile/settings.html",
                class: "navbar-item"
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.logged)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                to: "/profile/reports.html",
                class: "navbar-item"
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.logged)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 3,
                onClick: _withModifiers(_ctx.logout, ["prevent"]),
                to: "#",
                class: "navbar-item"
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    (_ctx.showHero)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
      : _createCommentVNode("", true)
  ]))
}